Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    return () => ({});
}
exports.default = default_1;
//# sourceMappingURL=empty.js.map